import React from "react"

/**
 * @param {{ visible: boolean, onClose: () => void }} props
 */
export function NavBackdrop({ visible, onClose }) {
    if (!visible) {
        return null
    }
    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-lg-none"
            style={{
                backgroundColor: "rgba(15, 97, 112, 0.5)",
                zIndex: 1040,
            }}
            onClick={onClose}
        />
    )
}
